module.exports = __webpack_public_path__ + "static/img/shokz.a5c5ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/shokz.png
// module id = toT7
// module chunks = 34